// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2Gd6P","approved":"Status_approved__1Z3xs","rejected":"Status_rejected__nvjqw","expired":"Status_expired__2nAdO","label":"Status_label__2ALmh"};